import { useEffect, useRef, useState } from 'react';

export function useDebounce<T>(value: T, delayMs: number = 400): T {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(
            () => {
                setDebouncedValue(value);
            },
            Math.max(0, delayMs)
        );

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [value, delayMs]);

    return debouncedValue;
}
